import { type FC } from 'react';
import cx from 'classnames';

import { useStyles } from './useStyles';

interface KpiCardProps {
  className?: string;
  metric: string;
  value: number | string;
  definition: string;
}

export const KpiCard: FC<KpiCardProps> = ({ className, metric, value, definition }) => {
  const styles = useStyles();

  const formattedValue =
    typeof value === 'number' && value < 1 && value > 0 ? `${(value * 100).toFixed(0)}%` : value;

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.metric}>{metric}</div>
      <div className={styles.value}>{formattedValue}</div>
      <div className={styles.definition}>{definition}</div>
    </div>
  );
};
